(function ($, Promise) {

	// Setup the prototype inheritance
	extend(BaseGame, Timeline);

	// Constructor
	function Timeline(id) {

		// Super constructor
		BaseGame.call(this);

		// Reset timer delay
		this.resetDelay = 60 * 1000;
		// this.resetDelay = -1;

		// Save game id
		this.id = id;

		// Screensaver animation
		this.screenSaverAnimationTimeout = false;
		this.sceenSaverAnimationTimeline = false;
		// this.screenSaverAnimationDelay = 120 * 1000;
		this.screenSaverAnimationDelay = -1;

		// Highlight
		this.highlightCycle = -1;
		this.highlightTimeout = false;
		this.handTimeline = false;

		// Close timeout
		this.closeTimeout = false;

		// Mask
		this.maskAnimationTimeline = false;

		// Override toolbar screen since we have a screensaver
		this.activateToolbarFrom = 2;

		// Variable to hold data
		this.data = {}

		// Load data then init
		this.loadData();
	}

	Timeline.prototype.loadData = function () {

		// Load JSON for ZONES
		var json1 = $.ajax({
			url: "data/timeline-" + this.id + ".json",
			dataType: 'json',
			cache: false,
			complete: $.proxy(function (data) {
				this.data = JSON.parse(data.responseText);
			}, this)
		});

		// Wait for all
		Promise.all([
			json1.promise(),
			// json2.promise(),
			// json3.promise(),
		]).then($.proxy(function () {
			this.initGame();
		}, this));

	};

	Timeline.prototype.initGame = function () {

		// Create items page
		$(this.data.items).each($.proxy(function (i, n) {

			// Clone
			var $el = $("#items-list-model").clone();

			// Main item
			$el.find("img.item-highlight").attr("src", n.desaturated_item_image);
			$el.attr("id", "item-" + i);
			$el.css({
				left: n.position.x + "px",
				top: n.position.y + "px",
			});

			// Popup box
			$el.find(".item-popup").css({
				"left": n.box.x,
				"top": n.box.y,
				"width": n.box.width,
				// "height": n.box.height,
				"background": "transparent url('" + this.data.base_blurred + "') no-repeat " + -n.box.x + "px " + -n.box.y + "px",
			});

			// Popup box
			if (typeof n.clickable_zone != "undefined") {
				$el.find(".clickable-zone").css({
					"left": n.clickable_zone.x + "px",
					"top": n.clickable_zone.y + "px",
					"width": n.clickable_zone.width + "px",
					"height": n.clickable_zone.height + "px",
				});
			}

			$el.find(".close-popup img").attr("id", "close-item-svg-" + i);
			$el.find(".item-popup-image > img").attr("src", n.image);
			$el.find(".item-popup-title .fr").html(n.title_fr);
			$el.find(".item-popup-title .en").html(n.title_en);
			$el.find(".item-popup-description .fr").html(n.description_fr);
			$el.find(".item-popup-description .en").html(n.description_en);

			// Init item specific CTA
			var $ctaEl = $("#cta-model").clone();
			$ctaEl.attr("id", "cta-" + i);
			$("#screen-2").append($ctaEl);
			$el.find(".item-popup-image > img").one("load", $.proxy(function (i) {
				// Wait for image to be loaded befor triggering updateCTAPosition
				this.updateCTAPosition($ctaEl, i);
			}, this, i));


			// Append to DOM
			$("ul.items-list").append($el);

		}, this));

		// Remove item model
		$("#items-list-model").remove();

		// Remove CTA model
		$("#cta-model").remove();

		// Set base image as main backgound image (reduce fading effect between screens)
		$("#base-image").css("background", "transparent url('" + this.data.base_normal + "') no-repeat center center")
		$("#base-image-blurred").css("background", "transparent url('" + this.data.base_blurred + "') no-repeat center center")

		// Title
		$(".title-box .title .fr").html(this.data.title_fr);
		$(".title-box .title .en").html(this.data.title_en);

		// Load SVGs
		convertSVGToInline();

		// On item click
		$("ul.items-list li.items-list-item .clickable-zone").on("click", $.proxy(function (e) {
			var id = $(e.currentTarget).parents("li").attr("id").replace("item-", "");
			this.audio.play(this.clickSound);
			this.openPopup(id);
		}, this));

		// On close item click
		$("ul.items-list li.items-list-item .close-popup").on("click", $.proxy(function (e) {
			this.audio.play(this.clickSound);
			this.closePopup();
		}, this));

		// On item image (viewer) click
		$("ul.items-list li.items-list-item .item-popup-image").on("click", $.proxy(function (e) {
			var id = $(e.currentTarget).parents("li").attr("id").replace("item-", "");
			this.openViewer(id);
		}, this));

		// On close viewer click
		$("#viewer .close-viewer").on("click", $.proxy(function (e) {
			this.audio.play(this.clickSound);
			this.closeViewer();
		}, this));


		// Go to first element
		this.goToScreen(1);
		// this.goToScreen(2);
	};


	Timeline.prototype.goToScreen = function (screenId, callback) {

		// Super constructor
		BaseGame.prototype.goToScreen.call(this, screenId, callback);

		if (screenId == 1) {
			this.requestSceenSaverAnimatonTimer(this.screenSaverAnimationDelay);
		} else if (screenId == 2) {
			this.requestSceenSaverAnimatonTimer(0, true);
			this.requestHighlightTimer(250);
		}

	}

	Timeline.prototype.requestHighlightTimer = function (delay, clearOnly) {

		// Stop current timeout
		if (this.highlightTimeout !== false) {
			clearRequestTimeout(this.highlightTimeout);
			this.highlightTimeout = false;
		}

		// Stop here if we wanted a clear only
		if (typeof clearOnly != "undefined" && clearOnly == true) {
			return;
		}

		// Request timeout
		this.highlightTimeout = requestTimeout($.proxy(this.highlightItemCycle, this), (delay || 5000));
	}

	Timeline.prototype.highlightItemCycle = function () {

		// Increment highlight cycle
		this.highlightCycle = (this.highlightCycle + 1) % ($("ul.items-list li").length + 1)
		var showAll = (this.highlightCycle == $("ul.items-list li").length);

		// Update currently highlighted item
		$("ul.items-list li.items-list-item").removeClass("highlighted");
		var highlightedItem = (!showAll) ? $("ul.items-list li.items-list-item").eq(this.highlightCycle) : $("ul.items-list li.items-list-item");
		highlightedItem.addClass("highlighted");

		// Stop current hand animation
		if (this.handTimeline !== false) {
			this.handTimeline.kill();
			this.handTimeline = false;
		}

		// Handle hand animation
		var $cta = (!showAll) ? $("#cta-" + this.highlightCycle) : $(".cta");
		this.handTimeline = new TimelineMax();
		this.handTimeline.fromTo($cta, 0.5, {autoAlpha: 0, scale: 0.8}, {autoAlpha: 1, scale: 1});
		this.handTimeline.fromTo($cta.find("circle:eq(1)"), 0.15, {alpha: 0, scale: 0.8, transformOrigin: "50% 50%"}, {alpha: 1, scale: 1});
		this.handTimeline.fromTo($cta.find("circle:eq(2)"), 0.15, {alpha: 0, scale: 0.8, transformOrigin: "50% 50%"}, {alpha: 1, scale: 1});
		this.handTimeline.fromTo($cta.find("circle:eq(3)"), 0.15, {alpha: 0, scale: 0.8, transformOrigin: "50% 50%"}, {alpha: 1, scale: 1});
		this.handTimeline.to($cta, 0.5, {autoAlpha: 0, scale: 0.8}, "+=1.5");

		// Request next timeout
		this.requestHighlightTimer((this.handTimeline.duration() * 1000) + 250);
	}


	Timeline.prototype.updateCTAPosition = function ($el, itemId) {
		var highlightedItem = $("ul.items-list li.items-list-item").eq(itemId);
		$el.css({
			"left": constrain(highlightedItem.position().left + highlightedItem.outerWidth() / 2, 100, 1800) + "px",
			"top": constrain(highlightedItem.position().top + highlightedItem.outerHeight() / 2, 100, 980) + "px",
		})
	}

	Timeline.prototype.openPopup = function (id) {

		// Close current popup if any
		this.closePopup();

		// Handle classes
		var $li = $("ul.items-list li.items-list-item").eq(id);
		$li.addClass("opened")
		var $box = $li.find(".item-popup");
		$box.addClass("opened")

		// Handle animation
		var tl = new TimelineMax();
		tl.fromTo($box, 0.5, {
			autoAlpha: 0,
			marginTop: -20,
		}, {
			autoAlpha: 1,
			marginTop: 0,
		});
		tl.fromTo($("#base-image-blurred"), 0.5, {autoAlpha: 0}, {autoAlpha: 1}, 0);


		// Handle animation
		// this.maskAnimationTimeline = new TimelineMax();
		// this.maskAnimationTimeline.staggerFromTo($li.find(".item-popup-image-mask"), 1.4, {
		// 	autoAlpha: 1,
		// }, {
		// 	autoAlpha: 0,
		// 	ease: Linear.easeNone,
		// }, 0.6, 0.1);

		// Replay video
		var curVid = $li.find('video').get(0);
		curVid.pause();
		curVid.currentTime = '0';
		curVid.play();

		// Clear highlight timer
		this.requestHighlightTimer(0, true);

		// Request timeout
		this.closeTimeout = requestTimeout($.proxy(this.closePopup, this), 9000);
	}

	Timeline.prototype.closePopup = function () {

		// Stop current timeout
		if (this.closeTimeout !== false) {
			clearRequestTimeout(this.closeTimeout);
			this.closeTimeout = false;
		}

		// Handle classes
		var $box = $("ul.items-list li.items-list-item .item-popup.opened").removeClass("opened");
		if ($box.length >= 1) {
			var tl = new TimelineMax();
			tl.to($box, 0.5, {autoAlpha: 0});
			tl.fromTo($("#base-image-blurred"), 0.5, {autoAlpha: 1}, {autoAlpha: 0}, 0);
		}

		// Handle animation
		$("ul.items-list li.items-list-item").removeClass("opened");
		$("ul.items-list li.items-list-item .item-popup").removeClass("opened");

		// Request next timeout
		this.highlightCycle = -1;
		this.requestHighlightTimer(2000);

		if (this.maskAnimationTimeline !== false) {
			this.maskAnimationTimeline.progress(1).kill();
			this.maskAnimationTimeline = false;
		}
	}

	Timeline.prototype.requestSceenSaverAnimatonTimer = function (delay, clearOnly) {

		// Stop current timeout
		if (this.screenSaverAnimationTimeout !== false) {
			clearRequestInterval(this.screenSaverAnimationTimeout);
			this.screenSaverAnimationTimeout = false;
		}

		if (this.sceenSaverAnimationTimeline !== false) {
			this.sceenSaverAnimationTimeline.progress(1).kill();
			this.sceenSaverAnimationTimeline = false;
		}

		// Stop here if we wanted a clear only
		if (typeof clearOnly != "undefined" && clearOnly == true) {
			return;
		}

		// Request timeout
		if (this.screenSaverAnimationDelay > -1) {
			this.screenSaverAnimationTimeout = requestInterval($.proxy(this.sceenSaverAnimation, this), delay);
		}
	}

	Timeline.prototype.sceenSaverAnimation = function () {

		// Handle animation
		this.sceenSaverAnimationTimeline = new TimelineMax();
		this.sceenSaverAnimationTimeline.to("#screen-1 .language-button.fr", 0.5, {
			x: "-=100",
			opacity: 0,
			ease: Sine.easeInOut
		}, "-=0.2");
		this.sceenSaverAnimationTimeline.to("#screen-1 .language-button.en", 0.5, {
			x: "+=100",
			opacity: 0,
			ease: Sine.easeInOut
		}, "-=0.2");
		this.sceenSaverAnimationTimeline.to("#base-image", 0.5, {
			opacity: 0,
			ease: Sine.easeInOut
		}, "-=0.2");
		this.sceenSaverAnimationTimeline.to("#base-image", 0.5, {
			opacity: 1,
			ease: Sine.easeInOut
		}, "+=0.7");
		this.sceenSaverAnimationTimeline.to("#screen-1 .language-button.fr", 0.5, {
			x: "+=100",
			opacity: 1,
			ease: Sine.easeInOut
		}, "-=0.2");
		this.sceenSaverAnimationTimeline.to("#screen-1 .language-button.en", 0.5, {
			x: "-=100",
			opacity: 1,
			ease: Sine.easeInOut
		}, "-=0.2");
	}

	Timeline.prototype.goToHome = function () {
		this.reset(1)
	}

	Timeline.prototype.goToScrenSaver = function () {

		// Super constructor
		var shouldReset = BaseGame.prototype.shouldReset.call(this);

		if (shouldReset) {
			this.reset(1);
		}
	}

	Timeline.prototype.reset = function (destinationScreen) {

		// Close current popup if any
		this.closePopup();

		// Handle highlight cycle
		this.highlightCycle = -1;
		this.requestHighlightTimer(0, true);
		$("ul.items-list li.items-list-item").removeClass("highlighted")
		$(".cta").css("visibility", "hidden");

		// Stop current hand animation
		if (this.handTimeline !== false) {
			this.handTimeline.kill();
			this.handTimeline = false;
		}

		// Define destination screen
		destinationScreen = destinationScreen || 1;

		// Go to screen
		this.goToScreen(destinationScreen);
	}


	// Expose Timeline
	window.Timeline = Timeline;

})(jQuery, Promise);